/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiApiImportListParams = zod.strictObject({
    app_id: zod.string().optional(),
    app_version: zod.string().optional(),
    format: zod.enum(['csv', 'json']).optional(),
    from_date: zod.iso.date().optional(),
    has_problem: zod.boolean().optional(),
    import_type: zod
        .enum(['bulk', 'instance', 'orgUnit', 'storageLog'])
        .nullish(),
    limit: zod.number().optional(),
    order: zod.string().optional(),
    page: zod.number().optional(),
    to_date: zod.iso.date().optional(),
    user_id: zod.number().optional(),
});

export type ApiApiImportListParams = zod.input<typeof ApiApiImportListParams>;
export type ApiApiImportListParamsOutput = zod.output<
    typeof ApiApiImportListParams
>;
